import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plain-footer',
  templateUrl: './plain-footer.component.html',
  styleUrls: ['./plain-footer.component.scss'],
})
export class PlainFooterComponent {
  @Input() background?: string;
}
